import { render, staticRenderFns } from "./CardOrganization.vue?vue&type=template&id=6ae3afad&scoped=true&"
import script from "./CardOrganization.vue?vue&type=script&lang=js&"
export * from "./CardOrganization.vue?vue&type=script&lang=js&"
import style0 from "./CardOrganization.vue?vue&type=style&index=0&id=6ae3afad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3afad",
  null
  
)

export default component.exports